export default "__VITE_ASSET__42d2920c__"